<template>
  <div class="promoter-bookings-related-bookings dbox">
    <NTable
      id="booking-promoters-promoter_sidewindow-related_bookings"
      :headers="headers"
      :items="bookings"
      :config="invoiceTableConfig"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td
            v-bind="tdcon('contact_name')"
            @click="onBookingStartDateClick(item)"
          >
            <span class="ut-link ut-text-accent5">{{
              item["start_date"]
            }}</span>
          </td>
          <td @click="onBookingArtistNameClick(item)" v-bind="tdcon('artist')">
            <span class="ut-link ut-text-accent5">{{
              item["artist_name"]
            }}</span>
          </td>
          <td v-bind="tdcon('status_color')">
            <div
              class="circle"
              :style="{
                backgroundColor:
                  '#' + (item['booking_status_colour'] || 'FFEFFF')
              }"
            ></div>
          </td>
          <td v-bind="tdcon('status_text')">
            <span>{{ item["booking_status_name"] }}</span>
            <!-- <div class="booking-status-cirtext">
              <div class="booking-status-cirtext--circle">
                <div class="circle" :style="{ backgroundColor: '#' + (item['booking_status_colour'] || 'FFEFFF' ) }"></div>
              </div>
              <div class="booking-status-cirtext--title">{{ item["booking_status_name"] }}</div>
            </div> -->
          </td>
          <td v-bind="tdcon('location')">
            <span>{{ item["booking_location_name"] }}</span>
          </td>
          <td v-bind="tdcon('city')">
            <span>{{ item["city"] }}</span>
          </td>
          <td v-bind="tdcon('date_name')">
            <span>{{ item["date_name"] }}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import {
  createNTableConfig,
  createTableHeader
} from "../../../../../plugins/datatable";
import {
  bookingListCalendarDateTabRoute,
  artistDetailsTabRoute
} from "../../../router/router";
import { bookingArtistListLDTRoutes } from "../../../router/routes";

export default {
  components: {
    // NTable,
    // Dropdown
  },
  props: ["selectedPromoterData"],
  data: function() {
    return {
      invoiceTableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true
      }),
      // artistCalendarDateModalContainer: false,
      // artistCalendarDateModal: false,
      // bookings: []
    };
  },
  watch: {
    // promoterBookings: function(n, o) {
    //   // console.log("Related Booking: ", n.bookings);
    //   this.bookings = n.bookings;
    // }
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("date", { text: false, f: 0.7 }), //
        createTableHeader("artist", { f: 1 }),
        createTableHeader("status_color", { text: false, f: 0.2 }),
        createTableHeader("status_text", {
          text: this.$t("status"),
          ta: "left",
          f: 1.3
        }),
        createTableHeader("location", { f: 1 }),
        createTableHeader("city", { f: 0.7 }),
        createTableHeader("date_name", { f: 1 })
      ];
    },
    bookings: function () {
      return this.selectedPromoterData ? this.selectedPromoterData.bookings : [];
    }
  },
  methods: {
    onBookingStartDateClick(item) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: { calendar_date_id: item.calendar_date_id, tab: "overview" }
      });
    },
    onBookingArtistNameClick(item) {
      //artistDetailsTabRoute
      // console.log(item);
      this.$router.push({
        name: bookingArtistListLDTRoutes.names.tab,
        params: {
          artist_id: item.artist_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>

<style lang="scss">
.promoter-bookings-related-bookings {
  .dt-ntable {
    td:nth-child(1) {
      flex: 0.7;
    }
    td:nth-child(2) {
      flex: 1;
    }
    td:nth-child(3) {
      flex: 0.2;
    }
    td:nth-child(4) {
      flex: 1.3;
      text-align: left !important;
    }
    td:nth-child(5) {
      flex: 1;
    }
    td:nth-child(6) {
      flex: 0.7;
    }
    td:nth-child(7) {
      flex: 1;
    }
  }
}
</style>
